/**
 * Tiny store wrapper. The store holds GameState and notifies subscribers on
 * change. Used by the view to render. Pure: state transitions go through
 * engine.reduce().
 */

import type { GameState } from '@/types/game';
import { emptyState, reduce, type GameAction } from './engine';

export interface Store {
  getState(): GameState;
  dispatch(action: GameAction): void;
  subscribe(listener: (state: GameState) => void): () => void;
}

export function createStore(initial: GameState = emptyState()): Store {
  let state = initial;
  const listeners = new Set<(state: GameState) => void>();
  return {
    getState: () => state,
    dispatch(action) {
      state = reduce(state, action);
      for (const l of listeners) l(state);
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
